import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";
export default class extends Controller {
  static targets = ["form", "loading", "venues", "shortlistButton", "input", "mobileInput"];

  connect() {
    if (this.hasShortlistButtonTarget) {
      this.shortlistButtonTargets.forEach((button) => {
        this.updateButtonState(button, button.dataset.id);
      });
    }
    this.submit = debounce(this.submit.bind(this), 500);
    this.toggleFormInputs();
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("updateShortlist", () => {
      if (this.hasShortlistButtonTarget) {
        this.shortlistButtonTargets.forEach((button) => {
          this.updateButtonState(button, button.dataset.id);
        });
      }
    });

    window.addEventListener("resize", this.toggleFormInputs.bind(this));
    document.addEventListener("turbo:load", this.toggleFormInputs.bind(this));
  }

  toggleFormInputs() {
    const isMobile = window.innerWidth < 640; // 640px is the breakpoint for mobile in Tailwind

    if (isMobile) {
      this.mobileInputTargets.forEach((mobileInput) => {
        mobileInput.removeAttribute("disabled");
      });
      this.inputTargets.forEach((input) => {
        input.setAttribute("disabled", "disabled");
      });
    } else {
      this.mobileInputTargets.forEach((mobileInput) => {
        mobileInput.setAttribute("disabled", "disabled");
      });
      this.inputTargets.forEach((input) => {
        input.removeAttribute("disabled");
      });
    }
  }

  getLocalStorageData() {
    const storedShortlistData = localStorage.getItem("shortlistData");
    if (storedShortlistData) {
      return JSON.parse(storedShortlistData);
    }
    return [];
  }

  submit() {
    this.showLoading();
    this.formTarget.requestSubmit();
  }

  removeFilter(event) {
    event.preventDefault();

    const paramName = event.currentTarget.dataset.removeFilterParam;
    const pill = event.currentTarget.closest("label");
    pill.classList.add("hidden");

    this.showLoading();

    const newURL = new URL(window.location.href);
    newURL.searchParams.delete(paramName);

    const inputs = this.formTarget.querySelectorAll(`[name="${paramName}"]`);
    inputs.forEach((input) => {
      if (input.type === "checkbox") {
        input.checked = false;
      }
      if (input.type === "radio") {
        input.checked = false;
      }
      if (input.tagName === "SELECT") {
        input.selectedIndex = 1;
      }
    });

    this.formTarget.action = newURL.toString();
    this.formTarget.requestSubmit();
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden");
    }
    if (this.hasVenuesTarget) {
      this.venuesTarget.classList.add("hidden");
    }
  }

  addToShortlist(event) {
    event.preventDefault();

    const venueData = { ...event.currentTarget.dataset };
    const storedShortlistData = this.getLocalStorageData();

    storedShortlistData.push(venueData);
    localStorage.setItem("shortlistData", JSON.stringify(storedShortlistData));

    document.dispatchEvent(new CustomEvent("updateShortlist"));

    window.sendSegmentAnalytics("Nok", "Memorial Venue Shortlist", "added", {
      venue_name: venueData.title,
      venue_type: venueData.type,
    });
  }

  updateButtonState(button, venueId) {
    const isInShortlist = this.isVenueInShortlist(venueId);
    const isShortlistFull = this.getLocalStorageData().length >= 3;
    button.disabled = isInShortlist || isShortlistFull;
  }

  isVenueInShortlist(venueId) {
    const storedShortlistData = this.getLocalStorageData();
    return storedShortlistData.some((item) => item.id === venueId);
  }
}
